export default "__VITE_ASSET__DnNKG$aV__"